<template>
  <div>
    <el-row style="margin:24px">
      <el-col :xl="4" :md="6">
        <span>
          盘库日期：{{ stockdate }}
        </span>
      </el-col>
      <el-col :xl="8" :md="10">
        <span>
          盘库单编号：{{ stockcode }}
        </span>
      </el-col>
      <el-col :xl="12" :md="14" v-if="reSubmit">
        <span>
          拒绝原因：{{ reason }}
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.NAME"></el-input>
          </el-form-item>
          <el-form-item label="自有分类：" :label-width="formLabelWidth">
            <el-select size="medium" v-model="searchForm.CATALOG_NAME" style="width:100%" clearable>
              <el-option v-for="item in catalogList" :key="item.CATALOG_NAME" :label="item.CATALOG_NAME" :value="item.CATALOG_NAME">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库位编码：" :label-width="formLabelWidth">
            <!-- <el-select v-model="searchForm.LOCATION_CODE" :filter-method="positionFilter" filterable> -->
            <el-select size="medium" v-model="searchForm.LOCATION_CODE" clearable>
              <el-option v-for="item in positionList" :key="item.ID" :label="item.CODE" :value="item.CODE"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="searchProduct()" style="float:right">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="leadingIn" style="float:right" v-if="!reSubmit">导入盘库</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin:10px 0">
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="45"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="产品类别" min-width="45"></el-table-column>
          <el-table-column prop="LOCATION_CODE" label="库位" min-width="45" v-if="WAREHOUSE_MODE == 2"></el-table-column>
          <el-table-column prop="PRODUCTION_DATE" label="生产日期" width="130"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="库存数量" min-width="45"></el-table-column>
          <el-table-column prop="PK_COUNT" label="现有数量" min-width="45">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PK_COUNT" @focus="getColumnRow(scope.row)" @change="setActualNumber" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="BEFORE_WORTH" label="盘前总额" min-width="45"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <div class="footer" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="total_count">
        </el-pagination>
        <el-button size="small" @click="sure()" style="float: right">确认盘库</el-button>
      </div>
    </el-row>
    <!-- --------------------导入盘库----------------------- -->
    <el-dialog title="导入盘库" center :visible.sync="leadingFormVisible" width="500px">
      <el-form :model="leadingForm" ref="leadingForm" size="small">
        <el-form-item :label-width="formLabelWidth">
          <span @click="leadingDownLoad" style="color:#409EFF;cursor:pointer;">点击此处下载导入模板</span>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
            :name="this.leadingForm.name" :multiple="false" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="leadingFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitLeadingIn">确 定</el-button>
      </div>
    </el-dialog>
    <!--确认盘库弹出框-->
    <el-dialog title="盘库变动产品信息" center :visible.sync="pkDialogVisible" width="50%">
      <el-table :data="dialogData" stripe border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" width="130"></el-table-column>
        <el-table-column prop="LOCATION_CODE" label="库位" width="130" v-if="WAREHOUSE_MODE == 2"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="库存数量" width="130"></el-table-column>
        <el-table-column prop="PK_COUNT" label="盘库数量" width="130"></el-table-column>
        <el-table-column label="数量差异" width="130">
          <template slot-scope="scope">
            <span :style="$_setFontColor(scope.row.PK_COUNT - scope.row.PRODUCT_COUNT)">
              {{ (scope.row.PK_COUNT - scope.row.PRODUCT_COUNT).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="BEFORE_WORTH"  label="盘前总额" min-width="45"></el-table-column> -->
      </el-table>
      <el-pagination @current-change="handleDialogChange" :current-page.sync="dialogPage" :page-size="changePageSize"
        layout="total,prev, pager, next, jumper" :total="dialog_count">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="updateClose()">取 消</el-button>
        <el-button size="small" type="primary" @click="reSubProductsToServer()" v-if="reSubmit">重新提交
        </el-button>
        <el-button size="small" type="primary" @click="subProductsToServer()" :disabled="isDisabledSubmit" v-else>确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  creatStokFun, addStokFun, queryPosition, downLoadStock, leadingInSuccess, searchProduct, setFontColor, queryStokDetailFun,
} from 'api/warehouseManager';
import date from '@/assets/common/date';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      fileList: [],
      url: '',
      leadingForm: {
        name: 'supplierPrice',
      },
      formLabelWidth: '110px',
      leadingFormVisible: false,
      // loading:false,
      PK_COUNT: 0,
      stockdate: '',
      stockcode: '',
      PK_ID: '',
      changeProducts: [],
      CURRENTDATE: date(Date.now(), '%F'),
      PROJECT_ID: '',
      PK_CODE: '',
      PK_WORTH: 0,
      tableData: [],
      dialogData: [],
      productPrice: 0,
      index: '',
      CODE: 0,
      // 弹出框显示
      pkDialogVisible: false,
      total_count: 0,
      currentPage: 1,
      changePageSize: 5,
      pageSize: 15,
      // 弹出框分页
      dialog_count: 0,
      dialogPage: 1,
      // 禁止盘库确认按钮
      isDisabledSubmit: false,
      ALL_PRODUCTS: [],
      ALL_CHANGE_PRODUCTS: [],
      searchForm: {
        NAME: '',
        CATALOG_NAME: '',
        LOCATION_CODE: '',
      },
      positionList: [],
      positionListAll: [],
      catalogList: [],
      SEARCH_PRODUCTS: [],
      ALL_PRODUCT_LISTS: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      reSubmit: this.$route.params.status == '202',
      reason: sessionStorage.getItem('reason'),
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.changePageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryPostionLi();
    if (!this.reSubmit) {
      this.queryData();
    } else {
      this.queryDetail();
    }
    this.queryCatalog();
  },
  methods: {
    queryPostionLi() {
      // if (this.POSITION_CONDITION.POSITIONLIST != null) {
      //   this.positionListAll = this.POSITION_CONDITION.POSITIONLIST;
      //   return;
      // }
      queryPosition()
        .then((result) => {
          this.positionList = result;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // positionFilter(query = '') {
    //   const arr = this.positionListAll.filter((item) => item.CODE.includes(query));
    //   if (arr.length > 50) {
    //     this.positionList = arr.slice(0, 50);
    //   } else {
    //     this.positionList = arr;
    //   }
    // },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    // 确定导入
    submitLeadingIn() {
      const params = {
        FILE_NAME: this.url,
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
      };
      if (!this.url) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      leadingInSuccess(params).then((res) => {
        this.tableData = res.map((item, index) => Object.assign(item, { PK_COUNT: item.PK_COUNT }));
        this.total_count = this.tableData.length;
        this.ALL_PRODUCTS = this.tableData;
        this.ALL_PRODUCT_LISTS = this.tableData;
        this.currentPage = 1;
        this.url = '';
        this.$refs.upload.clearFiles();
        this.loadPageProducts();
        this.leadingFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.url = '';
        this.$refs.upload.clearFiles();
      });
    },
    // 下载模板
    leadingDownLoad() {
      const params = {
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
      };
      downLoadStock(params).then((res) => {
        // window.location.href = res[0].FILE_PATH;
        window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导入盘库表
    leadingIn() {
      this.leadingFormVisible = true;
    },
    searchProduct() {
      this.currentPage = 1;
      if (this.searchForm.NAME !== '' && this.searchForm.CATALOG_NAME == '' && this.searchForm.LOCATION_CODE == '') {
        const tmpArr = this.ALL_PRODUCT_LISTS;
        this.SEARCH_PRODUCTS = tmpArr.filter((item) => item.PRODUCT_NAME.toLowerCase()
          .indexOf(this.searchForm.NAME.toLowerCase()) > -1);
        this.ALL_PRODUCTS = this.SEARCH_PRODUCTS;
      } else if (this.searchForm.CATALOG_NAME !== '' && this.searchForm.NAME == '' && this.searchForm.LOCATION_CODE == '') {
        const tmpArr = this.ALL_PRODUCT_LISTS;
        this.SEARCH_PRODUCTS = tmpArr.filter((item) => item.CATALOG_NAME.toLowerCase()
          .indexOf(this.searchForm.CATALOG_NAME.toLowerCase()) > -1);
        this.ALL_PRODUCTS = this.SEARCH_PRODUCTS;
      } else if (this.searchForm.LOCATION_CODE !== '' && this.searchForm.NAME == '' && this.searchForm.CATALOG_NAME == '') {
        const tmpArr = this.ALL_PRODUCT_LISTS;
        this.SEARCH_PRODUCTS = tmpArr.filter((item) => item.LOCATION_CODE.toLowerCase()
          .indexOf(this.searchForm.LOCATION_CODE.toLowerCase()) > -1);
        this.ALL_PRODUCTS = this.SEARCH_PRODUCTS;
      } else if (this.searchForm.NAME !== '' && this.searchForm.CATALOG_NAME !== '' && this.searchForm.LOCATION_CODE == '') {
        const tmpArr = this.ALL_PRODUCT_LISTS;
        this.SEARCH_PRODUCTS = tmpArr.filter((item) => item.PRODUCT_NAME.toLowerCase()
          .indexOf(this.searchForm.NAME.toLowerCase()) > -1);
        const dataArr = this.SEARCH_PRODUCTS;
        this.SEARCH_PRODUCTS = dataArr.filter((item) => item.CATALOG_NAME.toLowerCase()
          .indexOf(this.searchForm.CATALOG_NAME.toLowerCase()) > -1);
        this.ALL_PRODUCTS = this.SEARCH_PRODUCTS;
      } else if (this.searchForm.NAME !== '' && this.searchForm.CATALOG_NAME == '' && this.searchForm.LOCATION_CODE !== '') {
        const tmpArr = this.ALL_PRODUCT_LISTS;
        this.SEARCH_PRODUCTS = tmpArr.filter((item) => item.PRODUCT_NAME.toLowerCase()
          .indexOf(this.searchForm.NAME.toLowerCase()) > -1);
        const dataArr = this.SEARCH_PRODUCTS;
        this.SEARCH_PRODUCTS = dataArr.filter((item) => item.LOCATION_CODE.toLowerCase()
          .indexOf(this.searchForm.LOCATION_CODE.toLowerCase()) > -1);
        this.ALL_PRODUCTS = this.SEARCH_PRODUCTS;
      } else if (this.searchForm.NAME == '' && this.searchForm.CATALOG_NAME !== '' && this.searchForm.LOCATION_CODE !== '') {
        const tmpArr = this.ALL_PRODUCT_LISTS;
        this.SEARCH_PRODUCTS = tmpArr.filter((item) => item.CATALOG_NAME.toLowerCase()
          .indexOf(this.searchForm.CATALOG_NAME.toLowerCase()) > -1);
        const dataArr = this.SEARCH_PRODUCTS;
        this.SEARCH_PRODUCTS = dataArr.filter((item) => item.LOCATION_CODE.toLowerCase()
          .indexOf(this.searchForm.LOCATION_CODE.toLowerCase()) > -1);
        this.ALL_PRODUCTS = this.SEARCH_PRODUCTS;
      } else {
        if (this.searchForm.NAME !== '' && this.searchForm.CATALOG_NAME !== '' && this.searchForm.LOCATION_CODE !== '') {
          const tmpArr = this.ALL_PRODUCT_LISTS;
          this.SEARCH_PRODUCTS = tmpArr.filter((item) => item.PRODUCT_NAME.toLowerCase()
            .indexOf(this.searchForm.NAME.toLowerCase()) > -1);
          const dataArr = this.SEARCH_PRODUCTS;
          this.SEARCH_PRODUCTS = dataArr.filter((item) => item.CATALOG_NAME.toLowerCase()
            .indexOf(this.searchForm.CATALOG_NAME.toLowerCase()) > -1);
          const dataList = this.SEARCH_PRODUCTS;
          this.SEARCH_PRODUCTS = dataList.filter((item) => item.LOCATION_CODE.toLowerCase()
            .indexOf(this.searchForm.LOCATION_CODE.toLowerCase()) > -1);
          this.ALL_PRODUCTS = this.SEARCH_PRODUCTS;
        } else {
          this.ALL_PRODUCTS = this.ALL_PRODUCT_LISTS;
        }
      }
      this.total_count = this.ALL_PRODUCTS.length;
      this.loadPageProducts(0);
    },
    queryData() {
      creatStokFun().then((result) => {
        this.stockdate = result[0].PK_DATE;
        this.stockcode = result[0].PK_CODE;
        this.PK_ID = result[0].PK_ID;
        this.tableData = result[0].OP_ROLE.map((item, index) => Object.assign(item, { PK_COUNT: item.PRODUCT_COUNT }));
        this.ALL_PRODUCTS = this.tableData;
        this.ALL_PRODUCT_LISTS = this.tableData;
        this.total_count = this.tableData.length;
        this.loadPageProducts();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------确认盘库
    // sure () {
    //   this.dialogData = this.ALL_PRODUCT_LISTS.filter(item => item.PK_COUNT !== item.PRODUCT_COUNT)
    //   if (this.dialogData.length !== 0) {
    //     this.pkDialogVisible = true
    //     this.ALL_CHANGE_PRODUCTS = this.dialogData
    //     this.dialog_count = this.dialogData.length
    //     this.loadPageChangeProducts()
    //   } else {
    //     this.subProductsToServer()
    //   }
    // },
    sure() {
      this.dialogData = this.ALL_PRODUCTS.filter((item) => item.PK_COUNT !== item.PRODUCT_COUNT);
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      const flag = this.dialogData.find((item, index) => {
        if (!reg.test(item.PK_COUNT)) {
          return true;
        }
      });
      if (flag) {
        this.$message.show({ text: '请输入正数现有数量', type: 'warning' });
        return false;
      }
      this.pkDialogVisible = true;
      this.ALL_CHANGE_PRODUCTS = this.dialogData;
      this.dialog_count = this.dialogData.length;
      this.loadPageChangeProducts();
    },
    subProductsToServer() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.ALL_PRODUCT_LISTS.map((item, index) => ({
            PRODUCTION_DATE: item.PRODUCTION_DATE,
            PRODUCT_CODE: item.PRODUCT_CODE,
            BEFORE_COUNT: Number(item.PRODUCT_COUNT),
            PK_COUNT: Number(item.PK_COUNT),
            PRODUCT_PRICE: Number(item.PRODUCT_PRICE),
            BATCH: item.BATCH,
            LOCATION_ID: item.LOCATION_ID ? item.LOCATION_ID : 0,
            LOCATION_CODE: item.LOCATION_CODE ? item.LOCATION_CODE : '',
          }));
          const params = {
            PK_ID: this.PK_ID,
            PRODUCT_DATA: submitArr,
          };
          addStokFun(params).then((result) => {
            if (result) {
              if (result.length == 0) {
                this.$message.show({ text: '确认成功', type: 'success' });
                this.$router.push({ name: 'checkStock' });
                document.body.style.cursor = 'default';
              } else {
                document.body.style.cursor = 'default';
                window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
                this.$message.show({ text: '部分新增盘库产品失败', type: 'success' });
              }
            } else {
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
          document.body.style.cursor = 'default';
        } finally {
        }
      }
    },
    reSubProductsToServer() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // const submitArr = this.ALL_PRODUCTS.filter((item) => item.BEFORE_COUNT != item.AFTER_COUNT)
          const submitArr = this.dialogData.map((item, index) => ({
            PRODUCT_CODE: item.PRODUCT_CODE,
            BEFORE_COUNT: Number(item.PRODUCT_COUNT),
            AFTER_COUNT: Number(item.PK_COUNT),
            PRODUCT_PRICE: Number(item.PRODUCT_PRICE),
            ID: item.ID,
          }));
          const params = {
            SERVICE_ID: '10030',
            OTYPE: 18,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PK_ID: sessionStorage.getItem('pk_id'),
            PRODUCT_DATA: submitArr,
          };
          http.post(params).then((result) => {
            if (result) {
              if (result.length == 0) {
                this.$message.show({ text: '确认成功', type: 'success' });
                this.$router.push({ name: 'checkStock' });
                document.body.style.cursor = 'default';
              } else {
                document.body.style.cursor = 'default';
                window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
                this.$message.show({ text: '部分新增盘库产品失败', type: 'success' });
              }
            } else {
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
          document.body.style.cursor = 'default';
        } finally {
        }
      }
    },
    // -------------------------------------------改变实收数量触发
    setActualNumber(count) {
      if (!(/\d/.test(count))) {
        this.$message.show({ text: '请输入合法的实收数量', type: 'warning' });
        return false;
      }
    },
    // -----------------------------------------------分页加载当前产品
    loadPageChangeProducts(pageIndex = 0, changePageSize = this.pageSize) {
      const INDEX = pageIndex * changePageSize;
      const END = INDEX + changePageSize;
      if (END > this.ALL_CHANGE_PRODUCTS.length) {
        this.dialogData = this.ALL_CHANGE_PRODUCTS.slice(INDEX);
      } else {
        this.dialogData = this.ALL_CHANGE_PRODUCTS.slice(INDEX, END);
      }
    },
    handleDialogChange(page) {
      this.dialogPage = page;
      this.loadPageChangeProducts(page - 1);
    },
    // -----------------------------------------------分页加载当前产品
    loadPageProducts(pageIndex = 0, pageSize = this.pageSize) {
      const INDEX = pageIndex * pageSize;
      const END = INDEX + pageSize;
      if (END > this.ALL_PRODUCTS.length) {
        this.tableData = this.ALL_PRODUCTS.slice(INDEX);
      } else {
        this.tableData = this.ALL_PRODUCTS.slice(INDEX, END);
      }
    },
    // ----------------------------------页码改变时触发
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadPageProducts(page - 1);
    },
    getColumnRow() {
    },
    updateClose() {
      this.pkDialogVisible = false;
      // this.queryData()
    },
    // 获取自有分类
    queryCatalog() {
      searchProduct().then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 设置数量差异颜色显示
    $_setFontColor(number) {
      return setFontColor(Number(number));
    },
    queryDetail() {
      const data = {
        PK_ID: Number(sessionStorage.getItem('pk_id')),
        PK_CODE: sessionStorage.getItem('pk_code'),
      };
      queryStokDetailFun(data).then((result) => {
        if (result[0]) {
          this.tableData = result[0].PK_DETAIL.map((item, index) => Object.assign(item, { PRODUCT_COUNT: item.BEFORE_COUNT, PK_COUNT: item.AFTER_COUNT }));
          this.ALL_PRODUCTS = this.tableData;
          this.ALL_PRODUCT_LISTS = this.tableData;
          this.total_count = result[0].PK_DETAIL.length;
          this.stockdate = result[0].OP_ROLE[0].ENTRY_DATE;
          this.stockcode = result[0].OP_ROLE[0].PK_CODE;
          this.loadPageProducts();
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/entryStock.vue